<button class="btn btn-{{btnStyle}} {{styleClass}}" (click)="handleClick()" [disabled]="isLoading || !!disabled" [title]="title">
  <ng-container *ngIf="isLoading; else default">
    <app-spinner [size]="1"></app-spinner>
  </ng-container>
  <ng-template #default>
    <span *ngIf="icon" class="mr-2"><i class="{{icon}}"></i></span>
    <span v3-translate>{{label}}</span>
  </ng-template>
</button>
